import { Box, CircularProgress, Typography } from '@ace-clublabs/shared-component-library';

const Spinner: React.FC = () => {
  return (
    <Box id="spinner-box" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <CircularProgress aria-label="progress" id="spinner" variant="indeterminate" sx={{ marginBottom: '36px' }} />
      <Typography variant="b1Regular" component="h1">
        Hang tight while we get things ready for you.
      </Typography>
    </Box>
  );
};

export default Spinner;
